import apiClient from './axiosClient';

export const userApi = {
    getUsers: async (params) => {
        const res = await apiClient.get(`/api/users/by-parent/${params.userId}`);

        const data = res?.data;        

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    getProviderRoster: async (params) => {
        const res = await apiClient.get(`/api/provider/provideroster`);

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    getProviderRoster2: async (params = {}) => {
        const res = await apiClient.get('/api/provider/provideroster2', {
            params: {
                searchText: params.searchText || '',
                sortColumnName: params.sortColumnName || '',
                sortColumnDirection: params.sortColumnDirection || '',
                startIndex: params.startIndex ?? 0,
                pageSize: params.pageSize ?? 10,
                exportCsv: params.exportCsv ?? false,
            },
        });

        const data = res?.data;

        return {
            success: data?.Success ?? false,
            message: data?.Message || '',
            data: data?.Data || {},
        };
    },

    getUsersTaxIds: async (params) => {
        const res = await apiClient.get(`/api/provider/users/getUsersTaxId/${params.userId}`);

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    getUserRoles: async () => {
        const res = await apiClient.get(`/api/auth/roles`);

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    getOrganizations: async () => {        
        const res = await apiClient.get(`/api/provider/admin/user/getOrganization`);

        const data = res?.data;       

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    //getSystemUsers: async () => {

    //    const res = await apiClient.get(`/api/provider/admin/user/getAllUsers`);

    //    const data = res?.data;

    //  //  alert("HIT getSystemUsers: " + JSON.stringify(data));

    //    return {
    //        success: data?.Success,
    //        message: data?.Message,
    //        data: data?.Data || []   //  all properties preserved
    //    };
    //},

    getSystemUsers: async (params) => {

        const res = await apiClient.post(`/api/provider/admin/user/getAllUsers2`, {
            searchText: params.searchText,
            sortColumnName: params.sortColumnName,
            sortColumnDirection: params.sortColumnDirection,
            startIndex: params.startIndex,
            pageSize: params.pageSize
        });

        const data = res?.data;

        //  alert("HIT getSystemUsers: " + JSON.stringify(data));

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    
    changeUsersStatus: async (params) => {
        
        let userCurrentStatus = 0;
        if (params.userStatus.toLowerCase() === "active")
        {            
            userCurrentStatus = 1;
        }
        const res = await apiClient.put(`/api/users/status`, {
            UserId: params.userId,
            UserName: "",
            UserStatus:userCurrentStatus
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
      
  // params: { search, role, status }

    createUser: async (params) => {
        let status = false;
        if (params?.status?.toLowerCase() == "active") {
            status = true;
        }  

               
        const res = await apiClient.post('/api/provider/users/add', {
            username: params.userName,
            userRole: params.role,
            password: params.password,
            firstName: params.firstName,
            lastName: params.lastName,
            userType: "Provider",
            phone: params.phone.replace(/\D/g, ""),
            email: params.email,
            taxId: params.taxId,
            parentUserId: params.parentUserId,
            status:status,
            orgName: "",
            orgPhone: "",
            address: "",
            city: "",
            state: "",
            zipCode: "",
            registerfor: "Provider",            
            permission: ""
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };

        
    },
    createSuperAdminUser: async (params) => {

        //console.log("PARAMS : " + JSON.stringify(params));
        //alert("REACHED");
        //return;
        let status = false;
        if (params?.status?.toLowerCase() == "active") {
            status = true;
        }


        const res = await apiClient.post('/api/provider/users/add/superadmin', {
            username: params.userName,
           // userRole: "Super Admin",
            password: params.password,
            firstName: params.firstName,
            lastName: params.lastName,
            userType: "Provider",
            phone: params.phone.replace(/\D/g, ""),
            email: params.email,           
            status: status,            
            permission: JSON.stringify(params.selectedPermissions)
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };


    },

    resetPassword: async (params) => {        
        
        const res = await apiClient.post('/api/provider/user/changeUserPassword', {
            userId: params.userId,
            newPassword: params.newPassword            
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };


    },

    updateUser: async (params) => {
        
        let status = false;
        if (params?.status?.toLowerCase() == "active") {
            status = true;
        }     
        const res = await apiClient.put('/api/provider/users/update', {
            
            userId: params.id,
            userRole: params.role,           
            firstName: params.firstName,
            lastName: params.lastName,
            phone: params.phone.replace(/\D/g, ""),
            status: status,
            orgName: params.orgName,
            permission: JSON.stringify(params.selectedPermissions)
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };

        //hgh
    },

    deleteUser: async (params) => {        
        
        const res = await apiClient.delete(`/api/provider/users/deleteUser`, {
            //userId: params.UserId            
            data: {
                userId: params.UserId
            }
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    //apiClient.delete(`/users/${id}`),

    toggleStatus: async (params) => {

        let userCurrentStatus = 0;
        if (params.userStatus.toLowerCase() === "active") {
            userCurrentStatus = 1;
        }
        const res = await apiClient.put(`/api/users/status`, {
            UserId: params.userId,
            UserName: "",
            UserStatus: userCurrentStatus
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    approveUser: async (params) => {

        //alert("REACHED");
        //alert(JSON.stringify(params));
        //return;
        const res = await apiClient.post(`/api/provider/users/approve`, {
            userId: params.userId,                        
            approveStatus: params.currentapproveStatus.toString(),
            rejectReason: params.rejectReason
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    contact: async (params) => {

        
        const res = await apiClient.post(`/api/provider/user/contact`, {
            name: params.name,
            email: params.email,
            category: params.category,
            subject: params.subject,
            message: params.message
        });

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    groups: async () => {


        const res = await apiClient.get(`/api/provider/groups`);

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    userNotifications: async (params) => {

        const res = await apiClient.get(`api/notifications?userId=${params.userId}`);
        return res;
    },
    markUserNotificationAsRead: async (params) => {
        //const res = await apiClient.put(`/api/notifications/${params.id}/read?userId=${params.userId}`);
        //const res = await apiClient.put(`/api/notifications/read?userId=${params.userId}&ids=${params.ids.join(",")}`);

        
        await apiClient.put(
            `/api/notifications/read`,
            {
                userId: params.userId,
                ids: params.ids,
                
            }
        );
    },
    deleteUserNotification: async (params) => {
        
        await apiClient.delete(
            `/api/notifications/delete`,
            {
                data: {
                    userId: params.userId,
                    ids: params.ids
                }
            }
        );
    }
   
};
